$(function () {

	$('.ly-nav-main > .nav-li-item > a').on('click', function(e: any) {
		var megaMenu = $(this).parent().find('.ly-megamenu');
		if(megaMenu.length == 1) {
			e.preventDefault();
			if(megaMenu.hasClass('is-visible')) {
				hideNavigationItems();
			} else {
				showNavigationItems(megaMenu);
			}
		}
	})

	$('.co-toggle-trigger').click(function(){
		$(this).toggleClass('co-toggle-active').next('.co-toggle-item').slideToggle();
	});



	function showNavigationItems(navElem: any){
		$('header').addClass('nav-is-open');
		$('.ly-megamenu').removeClass('is-visible');
		navElem.addClass('is-visible');


	}

	function hideNavigationItems() {
		$('.ly-megamenu').removeClass('is-visible');
		$('header').removeClass('nav-is-open');
	}

	
	/* Open all PDF links in a new window */
	$('a[href$=".pdf"]').attr('target', '_blank');

  


	/* Mobile Navigation */
	$('.ly-hamburger').on("click", () => {
		$('.ly-hamburger').toggleClass('open');
    $('#nav-mobile').toggleClass('open');
		$('body').toggleClass('ly-disablescroll');
	});
	$('.ly-nav-mobile .ly-navopener').on('click', (e: any) => {
		var elem = e.currentTarget;
		var parentLi = $(elem).closest('li');
		console.log(parentLi)
		if(parentLi.hasClass('has-child')) {
			e.preventDefault();
			parentLi.find('> .ly-nav-child').slideToggle();
			parentLi.toggleClass('is-open')
		}
	})
	
	// $('#nav-mobile .ly-navopener').on('click', () => {
	// 	if(!$(event.currentTarget).parent().parent().hasClass('ly-active')) {
	// 		if(!$(event.currentTarget).parents('.has-child').hasClass('ly-active')) {
	// 			$('.ly-active').find('ul:first').slideUp();
	// 			$('.ly-active').removeClass('ly-active');
	// 		}
	// 		$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideDown();
	// 	} else {
	// 		$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideUp();
	// 	}
	// });



	/* Desktop Navigation */
	$('.ly-nav-sub .ly-navopener').on('click', () => {
		if(!$(event.currentTarget).parent().parent().hasClass('ly-active')) {
			if(!$(event.currentTarget).parents('.has-child').hasClass('ly-active')) {
				$('.ly-active').find('ul:first').slideUp();
				$('.ly-active').removeClass('ly-active');
			}
			$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideDown();
		} else {
			$(event.currentTarget).parent().parent().toggleClass('ly-active').find('ul:first').slideUp();
		}
	});


	/* mailencrypting */
	setTimeout(() => {
		$('[data-madr1]').not('.madr-done').each((i, item) => {
			const mailLinkElem = $(item);
			const maddr = mailLinkElem.attr('data-madr1') + '@' + mailLinkElem.attr('data-madr2') + '.' + mailLinkElem.attr('data-madr3');
			const linktext = mailLinkElem.attr('data-linktext') ? mailLinkElem.attr('data-linktext') : maddr;
			mailLinkElem.after('<a href="mailto:' + maddr + '">' + linktext + '</a> ');
			mailLinkElem.addClass('madr-done').hide();
		})
	}, 500);

	/* Go to top button */
	$('.ly-top').on('click', () => {
		$("html, body").animate({
			scrollTop: 0
		}, 1200);
		return false;
	});

	// Check if DNN < 9
	if ($("body.role-admin").length > 0) {
		if ($(".personalBarContainer").length > 0) {
			$("header").css("margin-top", "0");
		}
	}


	$(window).resize(() => {
		hideNavigationItems();
	})

	$(window).scroll(() => {
		if ($(this).scrollTop() > 200) {
			$('.ly-top').addClass('ly-top-visible');
		} else {
			$('.ly-top').removeClass('ly-top-visible');
		}
		hideNavigationItems();

	});

	// Sticky header
	var navheight = $('header').height();
	$(window).scroll(() => {
		if ($(window).scrollTop() >= navheight) {
			$('header').addClass('fixed-header');
			$('body').css('padding-top', navheight + 'px');
			$('body.va-layout-landingpage').css('padding-top', '0px');
			if ($(window).scrollTop() >= navheight + 1) {
				$('header').addClass('fixed-top');
			}
		} else {
			$('header').removeClass('fixed-header fixed-top');
			$('body').css('padding-top', '0px');
		}
	});
	// Dorpdown 
	$('.dropdown-has-child').click(function() {
		$('.sub-menu').toggleClass('visible');
	});
	$(".sub-menu").mouseleave(function(){
		$(this).removeClass('visible');
		});
	
});

